import request from '../request'
import qs from 'query-string'

// 获取所有权限列表
export function getAllPermissionListApi() {
  return request.get('/api/admin_user/permission')
}

// 新增权限
export function setPermissionStatusApi(params: any) {
  return request.post(`/api/admin_user/permission_create`, params)
}

// 修改权限
export function updatePermissionStatusApi(params: any) {
  return request.post(`/api/admin_user/permission_update`, params)
}

// 删除权限
export function deletePermissionApi(id: number) {
  return request.post(`/api/admin_user/permission_delete`, { id: id })
}

//获取账号
export function getAllAdminListApi(params: any) {
  const query = qs.stringify(params)
  // return request.get(`/admin/admin?${query}`)
  return request.get(`/api/admin_user/users?${query}`)
}

// 新增账号
export function setRoleStatusApi(params: any) {
  return request.post(`/api/admin_user/add`, params)
}

// 更新账号
export function updateRoleStatusApi(params: any) {
  return request.post(`/api/admin_user/update`, params)
}

// 删除账号
export function deleteAccoutApi(params: any) {
  return request.post(`/api/admin_user/delete`, params)
}

// 获取健康师
export function getHealthUserListApi() {
  return request.get(`api/admin_user/health_users`)
}


// 角色列表
export function getAllRoleListApi(page: number = 1, pageSize: number = 100000) {
  const query = qs.stringify({
    page: page,
    pageSize: pageSize
  })
  return request.get(`/api/admin_user/role?${query}`)
}

// 角色新增
export function setStatusApi(params: any) {
  return request.post('/api/admin_user/role_add', params)
}

// 角色编辑/禁用/启用
export function updateStatusApi(params: any) {
  return request.post('/api/admin_user/role_update', params)
}

// 删除角色
export function deleteRoleApi(id: number) {
  return request.post(`/api/admin_user/role_delete`, { id })
}

// 日志列表
export function getLogListApi(params: any) {
  let query = qs.stringify(params)
  return request.get(`/admin/log/login?${query}`)
} 

// 操作日志
export function getLogActionListApi(params: any) {
  let query = qs.stringify(params)
  return request.get(`/admin/log/action?${query}`)
}